import { Box, Typography } from "@material-ui/core"
import { BannerResponse } from "api"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"

const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 26px;
  span {
    color: black;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 40px;
    margin-top: 0px;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: right;
    width: 500px;
  }
`

const StyledExplanation = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 24px;
  font-weight: 100;
  text-align: right;
  color: #000;
  margin-top: 8px;
  line-height: 0.92;
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 20px;
    text-align: right;
  }
`

const StyledWrapper = styled(Box)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-top: -20px;
    padding: 0 16px;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    min-width: 375px;
    text-align: right;
  }
`
const StyledSpan = styled.h2<{
  $isDesktop: boolean
  $subTitleBolde: boolean
}>`
  margin: 0;
  padding: 0;
  line-height: normal;
  text-align: right;
  letter-spacing: 0.48px;
  font-size: 32px;
  color: #000000;
  font-weight: bold;
  line-height: 120%;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 40px;
  }
`
const StyledSubtitle = styled.span<{
  $isDesktop: boolean
  $subTitleBolde: boolean
}>`
  font-size: 20px;
  line-height: 0.8;
  font-family: Speedee, NarkisBlock;
  text-align: right;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  width: 100%;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;
  }
`
type MainBannerTextProps = {
  banner: BannerResponse
}

const MainBannerText = ({ banner }: MainBannerTextProps) => {
  const isDesktop = useIsDesktop()

  return (
    <StyledWrapper>
      <StyledTitle>
        <StyledSpan $isDesktop={isDesktop} $subTitleBolde={banner?.titleBolde}>
          {banner.title}
        </StyledSpan>
        <StyledSubtitle
          $isDesktop={isDesktop}
          $subTitleBolde={banner?.subTitleBolde}
        >
          {banner.subTitle}
        </StyledSubtitle>
      </StyledTitle>
      <StyledExplanation>{banner.text}</StyledExplanation>
    </StyledWrapper>
  )
}

export default MainBannerText
